// Theme: underground
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'underground',
  name: 'UNDERGROUND',
  tagline: 'UNDERGROUND',
  description: 'Cena underground com violeta urbano e progressao free leve.',
  category: 'urban-expression',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#1A1528', '#8B5CF6', '#252038', '#EDE9FE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 10px 24px rgba(0, 0, 0, 0.18)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 6%, transparent)'
    },
    shellClasses: 'font-sans theme-underground'
  },
  colorVars: {
    '--accent': '#8B5CF6',
    '--accent-foreground': '#1A1528',
    '--background': '#1A1528',
    '--border': '#5A4A8A',
    '--card': '#252038',
    '--card-border-active': 'rgba(139, 92, 246, 0.34)',
    '--card-completed': '#252038',
    '--card-foreground': '#EDE9FE',
    '--card-glow': 'rgba(139, 92, 246, 0.06)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#1A1528',
    '--foreground': '#EDE9FE',
    '--hold-fill': '#8B5CF6',
    '--input': '#252038',
    '--modal-bg': '#1A1528',
    '--modal-border': '#5A4A8A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 24px rgba(0, 0, 0, 0.18)',
    '--muted': '#5A4A8A',
    '--muted-foreground': '#EDE9FE',
    '--nav-active': '#8B5CF6',
    '--nav-bg': '#1A1528',
    '--popover': '#252038',
    '--popover-foreground': '#EDE9FE',
    '--primary': '#8B5CF6',
    '--primary-foreground': '#1A1528',
    '--ring': '#8B5CF6',
    '--secondary': '#5A4A8A',
    '--secondary-foreground': '#EDE9FE',
    '--streak': '#8B5CF6',
    '--success': '#22C55E',
    '--success-foreground': '#1A1528',
    '--xp': '#8B5CF6',
    '--xp-bg': '#252038'
  },
  resolvedVars: {
    '--accent': '#8B5CF6',
    '--accent-foreground': '#1A1528',
    '--accent-foreground-hsl': '256 31% 12%',
    '--accent-foreground-oklch': 'from #1A1528 l c h',
    '--accent-hsl': '258 90% 66%',
    '--accent-oklch': 'from #8B5CF6 l c h',
    '--background': '#1A1528',
    '--background-hsl': '256 31% 12%',
    '--background-oklch': 'from #1A1528 l c h',
    '--border': '#5A4A8A',
    '--border-hsl': '255 30% 42%',
    '--border-oklch': 'from #5A4A8A l c h',
    '--border-w': '1px',
    '--card': '#252038',
    '--card-border-active': 'rgba(139, 92, 246, 0.34)',
    '--card-completed': '#252038',
    '--card-completed-hsl': '253 27% 17%',
    '--card-completed-oklch': 'from #252038 l c h',
    '--card-foreground': '#EDE9FE',
    '--card-foreground-hsl': '251 91% 95%',
    '--card-foreground-oklch': 'from #EDE9FE l c h',
    '--card-glow': 'rgba(139, 92, 246, 0.06)',
    '--card-hsl': '253 27% 17%',
    '--card-oklch': 'from #252038 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#1A1528',
    '--destructive-foreground-hsl': '256 31% 12%',
    '--destructive-foreground-oklch': 'from #1A1528 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#EDE9FE',
    '--foreground-hsl': '251 91% 95%',
    '--foreground-oklch': 'from #EDE9FE l c h',
    '--hold-fill': '#8B5CF6',
    '--hold-fill-hsl': '258 90% 66%',
    '--hold-fill-oklch': 'from #8B5CF6 l c h',
    '--input': '#252038',
    '--input-hsl': '253 27% 17%',
    '--input-oklch': 'from #252038 l c h',
    '--modal-bg': '#1A1528',
    '--modal-bg-hsl': '256 31% 12%',
    '--modal-bg-oklch': 'from #1A1528 l c h',
    '--modal-border': '#5A4A8A',
    '--modal-border-hsl': '255 30% 42%',
    '--modal-border-oklch': 'from #5A4A8A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 24px rgba(0, 0, 0, 0.18)',
    '--muted': '#5A4A8A',
    '--muted-foreground': '#EDE9FE',
    '--muted-foreground-hsl': '251 91% 95%',
    '--muted-foreground-oklch': 'from #EDE9FE l c h',
    '--muted-hsl': '255 30% 42%',
    '--muted-oklch': 'from #5A4A8A l c h',
    '--nav-active': '#8B5CF6',
    '--nav-active-hsl': '258 90% 66%',
    '--nav-active-oklch': 'from #8B5CF6 l c h',
    '--nav-bg': '#1A1528',
    '--nav-bg-hsl': '256 31% 12%',
    '--nav-bg-oklch': 'from #1A1528 l c h',
    '--popover': '#252038',
    '--popover-foreground': '#EDE9FE',
    '--popover-foreground-hsl': '251 91% 95%',
    '--popover-foreground-oklch': 'from #EDE9FE l c h',
    '--popover-hsl': '253 27% 17%',
    '--popover-oklch': 'from #252038 l c h',
    '--primary': '#8B5CF6',
    '--primary-foreground': '#1A1528',
    '--primary-foreground-hsl': '256 31% 12%',
    '--primary-foreground-oklch': 'from #1A1528 l c h',
    '--primary-hsl': '258 90% 66%',
    '--primary-oklch': 'from #8B5CF6 l c h',
    '--radius': '12px',
    '--ring': '#8B5CF6',
    '--ring-hsl': '258 90% 66%',
    '--ring-oklch': 'from #8B5CF6 l c h',
    '--secondary': '#5A4A8A',
    '--secondary-foreground': '#EDE9FE',
    '--secondary-foreground-hsl': '251 91% 95%',
    '--secondary-foreground-oklch': 'from #EDE9FE l c h',
    '--secondary-hsl': '255 30% 42%',
    '--secondary-oklch': 'from #5A4A8A l c h',
    '--shadow-card': '0 10px 24px rgba(0, 0, 0, 0.18)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 6%, transparent)',
    '--streak': '#8B5CF6',
    '--streak-hsl': '258 90% 66%',
    '--streak-oklch': 'from #8B5CF6 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#1A1528',
    '--success-foreground-hsl': '256 31% 12%',
    '--success-foreground-oklch': 'from #1A1528 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(258 90% 66% / 0.15)',
    '--xp': '#8B5CF6',
    '--xp-bg': '#252038',
    '--xp-bg-hsl': '253 27% 17%',
    '--xp-bg-oklch': 'from #252038 l c h',
    '--xp-hsl': '258 90% 66%',
    '--xp-oklch': 'from #8B5CF6 l c h'
  }
}
